"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCollapseChildren = exports.StyledMutationHeader = exports.StyledCollapseHeaderIcon = exports.StyledHeaderContent = exports.StyledCollapseHeader = exports.StyledCollapseWrapper = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../general");
exports.StyledCollapseWrapper = (0, styled_components_1.default)(general_1.Paper) `
  ${({ customStyles, isMutationCard }) => {
    return (0, styled_components_1.css) `
      cursor: ${!isMutationCard ? 'pointer' : 'default'};
      ${customStyles !== null && customStyles !== void 0 ? customStyles : {}}
    `;
}}
`;
exports.StyledCollapseHeader = (0, styled_components_1.default)(general_1.Paper) `
  ${({ isMutationCard, isFirst }) => {
    return (0, styled_components_1.css) `
      cursor: ${!isMutationCard ? 'pointer' : 'default'};
      width: 100%;
      padding-inline: ${theme_1.paddings.collapse.desktop.inline};
      padding-block: ${theme_1.paddings.collapse.desktop.block};
      ${isMutationCard &&
        (0, styled_components_1.css) `
        border-top-left-radius: ${isFirst ? '8px' : '0'};
        border-top-right-radius: ${isFirst ? '8px' : '0'};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        z-index: 5;
      `}
      @media screen and (max-width: 767px) {
        padding-inline: ${theme_1.paddings.collapse.mobile.inline};
        padding-block: ${theme_1.paddings.collapse.mobile.block};
      }
    `;
}}
`;
exports.StyledHeaderContent = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ isChildrenStretched, innerChildrenCustomStyles }) => {
    return isChildrenStretched
        ? (0, styled_components_1.css) `
          & > div > * {
            align-self: stretch;
            align-items: flex-start;
            justify-content: flex-start;
          }
          ${innerChildrenCustomStyles !== null && innerChildrenCustomStyles !== void 0 ? innerChildrenCustomStyles : ``}
        `
        : ``;
}}
`;
exports.StyledCollapseHeaderIcon = (0, styled_components_1.default)(general_1.Flexbox) `
  transition: all 0.2s ease-in-out;
  rotate: ${({ isOpen }) => (isOpen ? '180deg' : '0deg')};
`;
exports.StyledMutationHeader = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ variant = 'neutral', isLast, isOpen }) => {
    return (0, styled_components_1.css) `
      background-color: ${theme_1.palette.system[variant]};
      padding: ${`${(0, utils_1.pxToRem)(5)} ${theme_1.spacings.s7}`};
      color: #ffffff;
      transition: all 0.2s ease-in-out;
      cursor: ${isLast ? 'pointer' : 'default'};
      ${isLast &&
        !isOpen &&
        (0, styled_components_1.css) `
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      `}

      h5 ~ div {
        margin-top: ${theme_1.spacings.s0};
        > div {
          z-index: 30;
          > svg {
            width: ${theme_1.spacings.s4};
            height: ${theme_1.spacings.s4};
            circle,
            path {
              stroke: #ffffff;
            }
            rect {
              fill: #ffffff;
            }
          }
          &:nth-child(2) {
            margin-top: ${theme_1.spacings.s2};
            left: 170%;
            &:after {
              top: 32%;
              right: 93%;
            }
          }
        }
      }
    `;
}}
`;
exports.StyledCollapseChildren = (0, styled_components_1.default)(general_1.Paper) `
  ${({ isOpen, isMutationCard }) => {
    return (0, styled_components_1.css) `
      width: 100%;
      max-width: 100%;
      transition: all 0.2s ease-in-out;
      height: ${isOpen ? 'auto' : '0px'};
      max-height: ${isOpen ? 'auto' : '0px'};
      overflow: hidden;
      padding-inline: ${theme_1.paddings.collapse.desktop.inline};
      padding-block: ${isOpen ? theme_1.paddings.collapse.desktop.block : '0px'};
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-top: ${isOpen
        ? isMutationCard
            ? 'none'
            : `1px solid ${theme_1.palette.grayScale[200]}`
        : 'none'};

      & > div {
        width: 100%;
      }
      @media screen and (max-width: 767px) {
        padding-inline: ${theme_1.paddings.collapse.mobile.inline};
        padding-block: ${isOpen ? theme_1.paddings.collapse.mobile.block : '0px'};
      }
    `;
}}
`;
//# sourceMappingURL=styles.js.map